export default "__VITE_ASSET__D4etM52___"